import { HttpClient } from '@angular/common/http';
import { environment } from '@environments';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Producto } from '@shared/models/despacho/Producto';
import { Injectable } from '@angular/core';
import { Producto as ProductoStock } from '@shared/models/stock/Producto';
import { Medicion } from '@shared/models/stock/Medicion';
import { ContenedorRespuesta } from '@shared/models/stock/ContenedorRespuesta';

@Injectable({
  providedIn: 'root'
})
export class MedicionesService {

  [x: string]: any;

  private stockbaseUrl = environment.apiServer.stockBaseUrl;
  private medicionesUrl = `${this.stockbaseUrl}/MedicionesV1`;
  private contenedoresUrl = `${this.stockbaseUrl}/ContenedoresV1`;
  private aeroplantasUrl = `${this.stockbaseUrl}/AeroplantasV1`;

  constructor(private httpClient: HttpClient) { }

  getMedicion(codigoTanque: string): Observable<Medicion>{
    const url = `${this.contenedoresUrl}/TelemedicionTanque/${codigoTanque}`
    return this.httpClient.get<Medicion>(url);
  }

  getMedicionesMasivas(aeroplanta: string): Observable<Medicion[]>{
    const url = `${this.aeroplantasUrl}/${aeroplanta}/Telemediciones`
    return this.httpClient.get<Medicion[]>(url)
      .pipe(
        tap(() => console.log('get Mediciones Masivas')),
        catchError(this.handleError)
      );
  }
  /**/
  getTodasLasMedicionesV2(codigoAeroplanta: string, codigoContenedor: string, fechaInicio: string, fechaFin: string): Observable<Medicion[]>{
    let url = `${this.contenedoresUrl}/Mediciones?fechaDesde=${fechaInicio}&fechaHasta=${fechaFin}&codigoAeroplanta=${codigoAeroplanta}`;
    if (codigoContenedor != null) url = url.concat(`&codigoContenedor=${codigoContenedor}`);
    return this.httpClient.get<Medicion[]>(url);
  }

  crearMedicion(medicion: Medicion): Observable<ContenedorRespuesta> {
    const url = `${this.contenedoresUrl}/Tanques/${medicion.codigoContenedor}/Mediciones`
    return this.httpClient.post<ContenedorRespuesta>(url, medicion)
      .pipe(
        tap(() => console.log('Creacion de medicion')),
        catchError(this.handleError)
      );
  }

  getConversionLitrosPorVarillado(codigoTanque: string, varillado: string): Observable<Medicion> {
    const url = `${this.medicionesUrl}/tanque/${codigoTanque}/varillado/${varillado}`;
    return this.httpClient.get<Medicion>(url)
      .pipe(
        tap(() => console.log('Creacion de medicion')),
        catchError(this.handleError)
      );
  }

  convertirProducto(p: Producto){
    const prod = new ProductoStock();
    prod.codigoProducto = p.codigoProducto;
    prod.nombreProducto = p.nombreProducto;
    prod.unidadMedida = Number(p.unidadMedida);
    return prod;
  }

  crearMedicionesMasivas(mediciones: Medicion[]){
    return this.httpClient.post<Medicion[]>(this.contenedoresUrl + '/Mediciones', mediciones);
  }
}
